import React from 'react';

import { useDispatch } from "react-redux";

import { formatCurrency } from "../../../common/utils";
import { removeFromCart } from "../../../redux/actions/cartActions";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import argan from '../../../assets/images/product/argan.png'

function CartItem(props) {
  const dispatch = useDispatch();
  const { image, name, price, quantity, cartId, slug, color, unit } = props;
  const removeProductHandle = (e) => {
    e.preventDefault();
    dispatch(removeFromCart(cartId));
    toast.error("Producto eliminado del carrito.");
  };
  return (
    <div className="cart-item">
      <div className="cart-item__image">
        <img src={image} alt="Product image" /> 
      </div>
      <div className="cart-item__info">
        <Link
          to={"/shop/product/" + slug}
        >
          <a>{name}</a>
        </Link>
        <p style={{fontSize: '12px', marginBottom: '10px'}}>{`${color}${unit}`}</p>
        <h5>{formatCurrency(price)}</h5>
        <p>
          Cantidad: <span>{quantity}</span>
        </p>
      </div>
      <a className="cart-item__remove" href="#" onClick={removeProductHandle}>
        <i className="fa fa-times"></i>
      </a>
    </div>
  );
}

export default CartItem;
